require("plugins/slider/slick");
require("plugins/waypoints/jquery.waypoints.min.js");
require("plugins/waypoints/sticky.min.js");
require("plugins/mousewheel/jquery.mousewheel.min.js");
require("plugins/modal/remodal");
var lazyLoader = require("luminoslabs/_lazy-loading");
require("plugins/show-hide/verndale.showhide");
require("plugins/verndale/ACnav");
require("jquery-mask-plugin");
require("plugins/verndale/ACdonate");
require("plugins/verndale/ACLinkIcons");
require("plugins/verndale/ACb2t");
require("plugins/verndale/ACtool");
require("plugins/verndale/heroSlider");
require("plugins/verndale/ACVideo");
require("plugins/verndale/ACexpand");
require("plugins/verndale/ImageSlider");
require("plugins/verndale/VideoSlider");
require("plugins/verndale/QuoteSlider");
require("plugins/verndale/wwdSlider");
require("plugins/verndale/statCount");
require("plugins/verndale/stayInformed");
require("plugins/verndale/hpLatest");
require("plugins/verndale/videoLand");
require("plugins/verndale/whSlider");
require("plugins/verndale/contactForm");
require("plugins/verndale/crisisHero");
require("luminoslabs/_hero-cta");
require("luminoslabs/_animation-module");
require("luminoslabs/_crisis-banner");
require("luminoslabs/_notify-me");
require("luminoslabs/_blog-post-listing");
require("luminoslabs/_multimedia-slideshow");
require("luminoslabs/_bg-video");
require("luminoslabs/_tweet");
require("luminoslabs/_sidebar-banner");

require("components/nav-search");

var snipeBannerComponent = require("luminoslabs/_snipe-banner");

$(function() {

    $('.mm-slideshow').multimediaSlideshow();

    $(".crisis-landing-wrap").crisisHero();

    $(".showHide").showHide();

    $(".header").navControls();

    $(".donate-form").donate();

    $(".link").linkIcons();

    $(".expandable-wrapper").acExpand();

    $(".b2t").not(".b2t--drawer").backToTop();

    $(".b2t--drawer").backToTop({
        sectionScroll: true,
        scrollParent: ".expandable-section"
    });

    $(".hero-slider-wrapper").heroSlider();

    $(".image-slider").imageSlider();

    $(".quote-slider").quoteSlider();

    $(".hero-tooltip").acTool();

    $(".video-module").not('.video-slider .video-module').videoModule();

    $('.video-slider').videoSlider();

    $(".vertical-slider-wrap").vertSlider();


    var waypoints = $('.social-module').not(".social-module--drawer").waypoint(function(direction) {
        if (direction === 'down') {
            $(".social-module").addClass("social-fixed")
        } else {
            $(".social-module").removeClass("social-fixed")
        }
    }, {
        offset: '60px'
    });

    var waypoints2 = $('.main-wrapper').waypoint(function(direction) {
        if (direction === 'up') {
            $(".social-module").not(".social-module--drawer").addClass("social-fixed")
        } else {
            $(".social-module").not(".social-module--drawer").removeClass("social-fixed")
        }
    }, {
        offset: 'bottom-in-view'
    });


    var heroHome = $('.hero-cta').waypoint(function(direction) {
        $('.hero-cta').addClass("animate");
        this.destroy();

    }, {
        offset: '90%'
    });

    var whHome = $('.health-wrap').waypoint(function(direction) {
        $('.health-wrap').addClass("showPlay");
        this.destroy();

    }, {
        offset: '20%'
    });

    $(".landing-stats-wrap").statCount();


    var wwdSettings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: false
    };

    $(window).on('resize', function() {
        if ($(window).width() >= 768 && $(window).width() <= 1024) {
            if (!$(".wwd-landing__slider").hasClass("slick-initialized")) {
                $(".wwd-landing__slider").slick(wwdSettings)
            }
        } else {
            if ($(".wwd-landing__slider").hasClass("slick-initialized")) {
                $(".wwd-landing__slider").slick("unslick");
            }
        }
    }).trigger("resize");


    var fundSettings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: false
    };

    $(window).on("resize", function() {
        if ($(window).width() <= 768) {
            if (!$(".three-col__list").hasClass("slick-initialized")) {
                $(".three-col__list").slick(fundSettings)
            }
        } else {
            if ($(".three-col__list").hasClass("slick-initialized")) {
                $(".three-col__list").slick("unslick");
            }
        }
    }).trigger("resize");


    $(window).on('resize', function() {

        if ($(window).width() > 768) {
            $(".crisis-link__icon use").each(function() {
                $(this).attr("xlink:href", "#right-arrow");
            });

            $(".ta-land__icon use").attr("xlink:href", "#right-arrow-o");

        } else {
            $(".crisis-link__icon use").each(function() {
                $(this).attr("xlink:href", "#right-angle-o");
            });

            $(".ta-land__icon use").attr("xlink:href", "#right-angle-o");
        }

    }).trigger("resize");


    $(".inform").stForm();

    $(".latest-wrap").hpLatest();

    $(".health-wrap").whLanding();

    $(".wh-slider-wrap").whSlider();

    $(".contact-form").contactForm();

    $(".hero-news").addClass("animate-in");

	var $splitStaticImageBlock = $(".split-static-image");
	$splitStaticImageBlock.waypoint(function() {
        $splitStaticImageBlock.addClass("animate-in");
    });

    var $headerWrapElem = $(".header__wrap");

    var stickyHeader = new Waypoint.Sticky({
        element: $headerWrapElem[0],
        wrapper: false
    });

    snipeBannerComponent.init({
        onCompleteAnimation: recreateStickyHeader
    });

    function recreateStickyHeader() {
        stickyHeader.destroy();
        stickyHeader = new Waypoint.Sticky({
            element: $headerWrapElem[0],
            wrapper: false
        });
    }

    if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
        $("body").addClass("no-fix")
    }

    lazyLoader.init();




});
